/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 19.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .controller('SettingsExternalAccountsController', [
    '$scope',
    'externalAccounts',
    'navigationService',
    function SettingsExternalAccountsController(
      $scope,
      externalAccounts,
      navigationService
    ) {
      $scope.accounts = [];
      navigationService.setSection(navigationService.SECTIONS.CORE);

      externalAccounts.all().then(function(accounts) {
        $scope.accounts = accounts;
      });
    }
  ]);
